// extracted by mini-css-extract-plugin
export const headBgColorExternal = "#ffffff";
export const headBgColorInternal = "#1c2234";
export const headBgColorShrunkSidebar = "#3c425a";
export const regular = "400";
export const medium = "500";
export const semibold = "600";
export const bold = "700";
export const sans = "'sans'";
export const serif = "'serif'";
export const atlasGrotesk = "'AtlasGrotesk'";
export const sections = "NetworthSummary__sections__ghe5r";
export const section = "NetworthSummary__section__LBmRr";
export const netWorth = "NetworthSummary__netWorth__jgL28";
export const pointing = "NetworthSummary__pointing__4btsZ";